import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Category } from 'src/app/models/category';
import { AnalitycsService } from 'src/app/services/analitycs.service';

@Component({
  selector: 'app-category-slides',
  templateUrl: './category-slides.component.html',
  styleUrls: ['./category-slides.component.scss']
})
export class CategorySlidesComponent implements OnInit {

  @Input() categorias: Category[];
  @Output() openCategorySel = new EventEmitter<Category>();

  constructor(private analytics: AnalitycsService) { }

  ngOnInit(): void {
  }

  openCategorySelected(category){
    this.analytics.logEvents("Categoria: " + category.name);
    this.openCategorySel.emit(category);
  }
}
